// GENERATED BY ./src/scripts/generateComponents.ts
// DO NOT EDIT IT MANUALLY

import React from "react";

import { iconStataebtc } from "../../../icons/full/build/icon-stataebtc.icon";
import { IconComponentBaseProps } from "../../../utils";
import { Image } from "../../Base/Image";

const StataebtcIcon = (props: IconComponentBaseProps) => {
  return <Image svgCode={iconStataebtc.data} {...props} />;
};

if (process.env.NODE_ENV !== 'production') {
  StataebtcIcon.displayName = 'StataebtcIcon';
}

export default StataebtcIcon;